import { NgModule } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';

import { SharedModule } from '../module';
import { NavHamburgerComponent } from './hamburger/hamburger';
import { NavLogoComponent } from './logo/logo';
import { NavPrimaryComponent } from './primary/primary';
import { XmNavChatComponent } from './chat/chat';
import { XmNavProfileComponent } from './profile/profile';
import { XmSubNavComponent } from './sub-nav/sub';
import { XmNavMenuItemComponent } from './menu-item/menu-item';
import { CbmNavMenuItemComponent } from './cbm-menu-item/cbm-menu-item';
import { XmNavCartComponent } from './cart/cart';

import { MyAccountMenuComponent } from './my-account/menu/menu';

@NgModule({
    declarations: [
        NavHamburgerComponent,
        NavLogoComponent,
        NavPrimaryComponent,
        XmNavChatComponent,
        MyAccountMenuComponent,
        XmNavProfileComponent,
        XmSubNavComponent,
        XmNavMenuItemComponent,
        CbmNavMenuItemComponent,
        XmNavCartComponent
    ],
    exports: [
        NavHamburgerComponent,
        NavLogoComponent,
        NavPrimaryComponent,
        XmNavChatComponent,
        XmSubNavComponent,
        MyAccountMenuComponent,
        XmNavProfileComponent,
        XmNavMenuItemComponent,
        CbmNavMenuItemComponent,
        XmNavCartComponent
    ],
    imports: [
        SharedModule,
        UIRouterModule
    ]
})
export class NavModule {}
